/* import __COLOCATED_TEMPLATE__ from './infinite-scroll.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class InfiniteScroll extends Component {
  @tracked observer = null;

  @action
  setObserver(root) {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (root) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.args.onTrigger();
          }
        });
      }, { root, rootMargin: "250px", threshold: 0 });
    }
  }

  willDestroy() {
    super.willDestroy();
    this.observer.disconnect();
  }
}
